import React from 'react';
import { Pane, Text } from '@leverege/ui-elements';
import { CHANGE_STATES } from '../../attributes/OperationStateChangeStatus';
import { jsx as _jsx } from "react/jsx-runtime";
const VARIANTS = {
  [CHANGE_STATES.COMPLETE]: 'detailPillSuccess',
  [CHANGE_STATES.PENDING]: 'detailPillWarning'
};
export default function OperationStateChangeStatus(props) {
  const {
    value,
    defaultValue = null
  } = props;
  if (value == null) {
    return defaultValue;
  }
  return /*#__PURE__*/_jsx(Pane, {
    layout: "flex:rowM",
    style: {
      overflow: 'hidden'
    },
    children: /*#__PURE__*/_jsx(Text, {
      variant: VARIANTS[value] || 'pill',
      children: value
    }, value)
  });
}